import { gql } from "@apollo/client";

export const BUILDING_CONTACT_INFO_FIELDS_FRAGMENT = gql`
  fragment BuildingContactInfoFieldsV2 on BuildingInterface {
    id
    slug
    contactName
    contactPhone
    contactEmail
    url
    applicationUrl
    hasFcfs
    geocode {
      id
      latitude
      longitude
      formattedAddress
    }
    documents {
      id
      name
      category
      fileUrl
      filename
      extension
      __typename
    }
    housingVacancy {
      id
      documents {
        id
        name
        category
        fileUrl
        filename
        extension
        __typename
      }
    }
    housingLottery {
      id
      contactEmail
      contactName
      contactPhone
      ownContactInfo
      notifyPropertyContact
      startDate
      url
      documents {
        id
        name
        category
        fileUrl
        filename
        extension
        __typename
      }
      __typename
    }
    __typename
  }
`;

export default BUILDING_CONTACT_INFO_FIELDS_FRAGMENT;
